import "./Poojas.css";
// import { useNavigate } from "react-router-dom";

function Poojas() {
  // const navigate = useNavigate();
  const clickHandle = () => {
    window.open(
      "https://tms.ap.gov.in/#/temple-details/MDSMPL?section=seva",
      "_blank",
    );
  };

  return (
    <div className="pooja-container">
      <div className="pooja-card">
        <div className="pooja-heading">ఏకాదశి రుద్రాభిషేకం (పరోక్ష)</div>
        <div className="pooja-data">
          హోమం అనేది శివుడు తన పదకొండు రూపాలకు రుద్రుడిగా చేసిన చాలా శక్తివంతమైన
          ఆచారం. రుద్ర రూపాలను ఆవాహన చేసేందుకు రుద్ర మంత్రాలను పదకొండు సార్లు
          జపిస్తారు. అన్ని పనులలో శాంతి మరియు విజయాన్ని పొందడానికి ఇది చాలా
          ఉపయోగకరమైన పద్ధతి.
        </div>
        <button type="button" className="pooja-button" onClick={clickHandle}>
          Book Now
        </button>
      </div>
      <div className="pooja-card">
        <div className="pooja-heading">
          మహాన్యాసపూర్వక ఏకవార రుద్రతైలాభిషేకం (పరోక్ష)
        </div>
        <div className="pooja-data">
          రుద్రాభిషేకం పూజ ప్రతికూలత, చెడు కర్మలను తొలగించడంలో సహాయపడుతుంది
          మరియు జీవితంలో రక్షణను ఇస్తుంది. ఈ పూజ చంద్రుని ప్రతికూల ప్రభావాలను
          వదిలించుకోవడానికి మరియు బలమైన మనస్సు, మంచి ఆరోగ్యం, సామరస్యం మరియు
          సంపదను కలిగి ఉండటానికి సహాయపడుతుంది.
        </div>
        <button type="button" className="pooja-button" onClick={clickHandle}>
          Book Now
        </button>
      </div>
      <div className="pooja-card">
        <div className="pooja-heading">శని జపం (పరోక్ష)</div>
        <div className="pooja-data">
          శని జపం ఒక వ్యక్తి కెరీర్ లేదా వ్యాపార జీవితంలో గొప్ప ఎత్తులకు
          చేరుకోవడానికి సహాయపడుతుంది. ఇది ఒక వ్యక్తి జీవితంలో విజయం సాధించడానికి
          కూడా సహాయపడుతుంది. ఇది జ్ఞానం, ఆర్థిక శ్రేయస్సు, మంచి ఆరోగ్యం మరియు
          శత్రువులను మరియు చెడు కళ్ళను వదిలించుకోవడానికి సహాయపడుతుంది.
        </div>
        <button type="button" className="pooja-button" onClick={clickHandle}>
          Book Now
        </button>
      </div>
      <div className="pooja-card">
        <div className="pooja-heading">శని శాంతి హోమం (పరోక్ష)</div>
        <div className="pooja-data">
          వేద గ్రంధాల ప్రకారం, జన్మ చార్ట్‌లో శని గ్రహం యొక్క బలహీన స్థానం లేదా
          పరివర్తన ఆర్థిక, డబ్బు నష్టం, ఆరోగ్య సమస్యలు మరియు ఇతర సమస్యలను
          కలిగిస్తుంది. వాటిని నిరోధించాలనుకునే ఎవరైనా ప్రమాదాలను విస్తృతంగా
          తగ్గించడానికి శాంతి గ్రహ శాంతి హోమంపై దృష్టి పెట్టాలి.
        </div>
        <button type="button" className="pooja-button" onClick={clickHandle}>
          Book Now
        </button>
      </div>
    </div>
  );
}

export default Poojas;
